<template>
  <div v-if="isContractor || isPartner" class="enhancify grid-module">
    <h1>Billing</h1>
    <div class="columns">
      <div class="column payment-card-wrapper">
        <contractor-cards
            :add-card-immediately="$route.params.action === 'add-card'"
            :update-card-immediately="$route.params.action === 'update-card'"
        />
      </div>
      <div class="column failed-payments-wrapper">
        <contractor-failed-payments></contractor-failed-payments>
      </div>
    </div>
    <contractor-payments></contractor-payments>
  </div>
</template>

<script>
import ContractorCards from '@/components/CardsPayments/ContractorCards.vue';
import ContractorFailedPayments from '@/components/CardsPayments/ContractorFailedPayments.vue';
import ContractorPayments from '@/components/CardsPayments/ContractorPayments.vue';

export default {
  name: 'CardPayments',
  components: { ContractorPayments, ContractorCards, ContractorFailedPayments },
  computed: {
    isContractor() {
      return !!this.$store.state.contractor.id;
    },
    isPartner() {
      return !this.$store.state.contractor.id
          && !!this.$store.state.partner.id;
    },
  },
};
</script>

<style scoped lang="stylus">
.columns
  column-gap 10px
@supports (-webkit-hyphens:none)
  .grid-module
    height unset
@media screen and (min-width: 769px)
  .column.payment-card-wrapper
    max-width: 570px;
  .column.failed-payments-wrapper
    max-width 570px
</style>
